import React from 'react'
import { ECharts, HeaderComp, Spiner } from '../../components'

const OverviewChart = ({ option, title, loading = false }) => {

    return (
        <div className="item_comp" >
            <HeaderComp title={title} />
            {loading ? <Spiner /> : <ECharts option={option} />}
        </div>
    )
}

export default OverviewChart